import ProductCard from '@ui/Product/Card/component'
import Slider from '@ui/Slider/component'

export default (rootEl: HTMLElement): void => {
  if (!rootEl) {
    return
  }

  const sliderEl = rootEl.querySelector<HTMLElement>('.slider')

  if (!sliderEl) {
    return
  }

  Slider(sliderEl, {
    navigation: {
      prevEl: rootEl.querySelector<HTMLElement>('.slider-navigation [data-direction="left"]'),
      nextEl: rootEl.querySelector<HTMLElement>('.slider-navigation [data-direction="right"]'),
    },
    pagination: {
      el: rootEl.querySelector<HTMLElement>('.slider-pagination') ?? null,
    },
    on: {
      init: () => {
        rootEl.querySelectorAll<HTMLElement>('.product-card').forEach((el) => {
          ProductCard(el)
        })
      },
    },
  })
}
